import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { EmptyStateDirective } from '@app/infrastructure/state-switcher/directives/empty-state.directive';
import { ErrorStateDirective } from '@app/infrastructure/state-switcher/directives/error-state.directive';
import { LoadingStateDirective } from '@app/infrastructure/state-switcher/directives/loading-state-directive';
import { IWidgetState, IWidgetStates } from '@app/infrastructure/state-switcher/state-switcher.model';

@Component({
	selector: 'app-state-switcher',
	templateUrl: './state-switcher.component.html',
	styleUrls: ['./state-switcher.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StateSwitcherComponent implements OnChanges {
	@Input() public state: IWidgetState | null = { isEmpty: false, isLoading: false, isError: false };
	// Default error state outputs
	@Output() public reloadWidget = new EventEmitter();

	@ContentChild(EmptyStateDirective) public emptyStateContent: EmptyStateDirective | undefined;
	@ContentChild(ErrorStateDirective) public errorStateContent: ErrorStateDirective | undefined;
	@ContentChild(LoadingStateDirective) public loadingStateContent: LoadingStateDirective | undefined;

	public readonly STATE_TYPES: typeof IWidgetStates = IWidgetStates;

	public ngOnChanges({ state }: SimpleChanges): void {
		if (state?.currentValue) {
			this.state = state.currentValue;
		}
	}

	public get currentState(): IWidgetStates {
		if (this.state?.isError) {
			return IWidgetStates.ERROR;
		}
		if (this.state?.isLoading) {
			return IWidgetStates.LOADING;
		}
		if (this.state?.isEmpty) {
			return IWidgetStates.EMPTY;
		}

		return IWidgetStates.DEFAULT;
	}
}
